var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgComment(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.91667 6.41667H10.75M4.91667 9.75H9.08333M0.750024 8.08336C0.747156 9.18325 1.00413 10.2683 1.50002 11.25C2.088 12.4265 2.9919 13.416 4.11048 14.1078C5.22907 14.7995 6.51816 15.1662 7.83336 15.1667C8.93325 15.1696 10.0183 14.9126 11 14.4167L15.75 16L14.1667 11.25C14.6626 10.2683 14.9196 9.18325 14.9167 8.08336C14.9162 6.76815 14.5495 5.47907 13.8578 4.36048C13.166 3.2419 12.1765 2.338 11 1.75002C10.0183 1.25413 8.93325 0.997156 7.83336 1.00002H7.41669C5.67973 1.09585 4.03915 1.82899 2.80907 3.05907C1.57899 4.28915 0.84585 5.92973 0.750024 7.66669V8.08336Z",
    stroke: "#001A72",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgComment);
export default __webpack_public_path__ + "static/media/comment.6f48d2da2d29ef60d0b34d3c833ad071.svg";
export { ForwardRef as ReactComponent };